<template>
    <div id="collectieve-beveiliging-leiden-bio-science" class="container mt-5">
        <h1>
            <span>
                Collectieve Beveiliging&nbsp;
            </span>
        </h1>
        <h1 class="mt-5 mb-3">
            <small class="text-muted">Leiden | Oegstgeest | Leiderdorp</small>
        </h1>

        <h3>Wat is Collectieve Beveiliging?</h3>
        <p>Collectieve beveiliging houdt in dat een groot aantal bedrijven in een bepaald gebied gezamenlijk betaalt voor <strong>permanente aanwezigheid</strong> van één of meer surveillancewagens op het terrein.</p>
        
        <h3>Waarom Collectieve Beveiliging?</h3>
        <p>Door permanente aanwezigheid zijn wij in staat om snel en <strong>adequate opvolging</strong> te geven bij een alarmmelding en/of ongeregeldheden. We zijn bekend met het terrein en door het zichtbaar preventief surveilleren wordt het een stuk onaantrekkelijker voor kwaadwillenden.</p>
        <p>Daarnaast kunnen de kosten als eventuele schade zoveel mogelijk beperkt worden. Dit doen wij op een duurzame manier, middels duurzame voertuigen en goede zorg voor onze beveiligers. Daarnaast dragen wij als erkend leerbedrijf een <strong>maatschappelijke verantwoordelijkheid</strong> door opleidingsplaatsen aan te bieden aan onze (toekomstige) beveiligers en ze te begeleiden op de arbeidsmarkt.</p>

        <h3>Meer weten? Meld je vrijblijvend aan.</h3>
        <div class="row pt-5">
            <div class="col-md-6 offset-md-3">
                <contact-form subject="Collectieve Beveiliging"></contact-form>
            </div>
        </div>

        <hr />
        <h4 class="text-muted text-center mt-5">Dit is in samenwerking met:</h4>
        <div class="row mt-5">
            <div class="col-md-4 offset-md-2">
                <a href="https://veiligheidsteam.nl" target="_blank">
                    <card icon="/img/veiligheidsteam-200x14.webp" title="VEILIGHEIDSTEAM.NL" description="Van plan tot levering en coördinatie van professionals. Totale ontzorging voor elk veiligheidsvraagstuk."></card>
                </a>
            </div>
            <div class="col-md-4">
                <a href="https://rijnlandbeveiliging.nl" target="_blank">
                    <card icon="/img/rijnland.webp" title="RIJNLAND BEVEILIGING" description="Gecertificeerde beveiligings professionals en technologische oplossingen. Want zonder adequate opvolging is technologische innovatie waardeloos."></card>
                </a>
            </div>
        </div>
        <hr />
        <h4 class="text-muted text-center mt-5">Onze andere dienstverlening:</h4>
        <div class="row mt-5 mb-5">
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'objectbeveiliging' } }">
                    <card title="Objectbeveiliging" description="Objectbeveiliging is het geheel van beveiliging-, portiers- en/of receptiediensten op een bepaald object. Door het verrichten van regelmatige controlerondes en het signaleren van onregelmatigheden worden alle voor het object vitale, ruimtes gecontroleerd."></card>
                </router-link>
            </div>
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'receptionist' } }">
                    <card title="Receptionisten" description="Een receptionist is het eerste aanspreekpunt van de organisatie. Ze ontvangen de bezoekers, cliënten, klanten, leveranciers en collega’s. Ze wijzen de weg, beantwoordt vragen, verstrekken relevante informatie en beantwoordt de telefoon."></card>
                </router-link>
            </div>
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'nachtbewaking' } }">
                    <card title="Nachtbewaking" description="Permanente bewaking en toezicht gedurende de nachtelijke uren, ontvangen van bezoekers en het weren van ongenodigde gasten."></card>
                </router-link>
            </div>
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'brand- en sluitrondes' } }">
                    <card title="Brand- en Sluitrondes" description="Nadat al het personeel het pand heeft verlaten, wordt een interne controle uitgevoerd of er geen personen meer aanwezig zijn en of alle deuren en ramen zijn gesloten en het alarmsysteem ingeschakeld staat."></card>
                </router-link>
            </div>
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'alarmopvolging' } }">
                    <card title="Alarmopvolging" description="Wanneer indringers uw pand/woning proberen binnen te dringen, zal het alarm afgaan. Meteen na het afgaan van het alarm zal een melding binnenkomen bij de meldkamer waar u aangesloten bent. Dit signaal zal uiteraard ook bij de meldkamer worden geregistreerd. De meldkamer zal per direct contact opnemen met de Beveiliging, die als sleutelhouder functioneert."></card>
                </router-link>
            </div>
            <div class="col-md-4">
                <router-link tag="a" :to="{ name: 'InformationSecurityDetail', params: { detail: 'bhv' } }">
                    <card title="BHV" description="Elke organisatie moet maatregelen treffen voor het omgaan met noodsituaties zoals brand. Dit vindt plaats met de hulp van eigen medewerkers, de zogenaamde bedrijfshulpverleners (BHV’ers) op basis van een bedrijfshulpverleningplan."></card>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import Card from '@/components/Card'
import Loader from '@/components/Loader'
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        Card,
        Loader,
        ContactForm
    },
    data() {
        return {
            form: {
                company: null,
                name: null,
                phone: null,
                email: null
            }
        }
    }
}
</script>

<style scoped lang="scss">
a {
    text-decoration: none;
    color: $darkColor;
}
</style>